import dynamic from 'next/dynamic';
import { useState, useEffect } from "react";
import styles from '../../styles/GridLayout.module.css';
import Link from 'next/link';
import CanvasGrid from "../../src/components/CanvasGrid";
import MobileCanvas from "../../src/components/MobileCanvas";

const Ad_120x600 = dynamic(() => import('../../src/ads/Ad_120x600'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});
const Ad_300x250_1 = dynamic(() => import('../../src/ads/Ad_300x250_1'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});
const Ad_300x250_2 = dynamic(() => import('../../src/ads/Ad_300x250_2'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});
const Ad_728x90 = dynamic(() => import('../../src/ads/Ad_728x90'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});
const Ad_728x90_Bot = dynamic(() => import('../../src/ads/Ad_728x90_Bot'), {
  ssr: false,
  loading: () => <p>Loading Ad...</p>,
});

const GridLayout = ({ items, game, mOncliock }) => {
  const [isSmall, setSmall] = useState(false);
  const [mobile, setMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      setMobile(isMobile);
      setSmall(window.innerWidth < 300 || isMobile);
    };

    // Set initial states
    handleResize();

    // Add event listener
    window.addEventListener('resize', handleResize);

    // Cleanup event listener on unmount
    return () => window.removeEventListener('resize', handleResize);
  }, []); // Empty dependency array ensures this runs once on mount and cleanup on unmount


  return (
    <div className={styles.gridContainer}>
    
    <div className={`${styles.gridItem} ${styles.MediumBanner}`}
          >
            <Ad_300x250_1/>
            <Ad_300x250_2/>
            
          </div>

          <div className={`${styles.gridItem} ${styles.Wide_Skyscraper}`}
          ><Ad_120x600/></div>
    <div className={`${styles.gridItem} ${styles.specialItem}`}
    
          > 
         
            {!isSmall && (
            <CanvasGrid
            brand={game?.brand}
            iframe={game?.iframe}
            name={game?.name[0]}
            />
          )}
          {isSmall && (
            <MobileCanvas
              thumb={game?.thumb}
              name={game?.name[0]}
              platform={game?.platform}
              onClick={mOncliock}
            />
          )}
          
          </div>
        
<div className={`${styles.gridItem} ${styles.Wide_Skyscraper2}`}
          ><Ad_120x600/></div>
         <div className={`${styles.gridItem} ${styles.Leaderboard}`}
          ><Ad_728x90/></div>
         
      {Object.entries(items).map(([category, url], index) => (
        // Leaderboard
          <div key={index}>
          </div>
      ))}
    </div>
  );
};

export default GridLayout;
